<template>
  <div class="page-root">
    <div class="page-wrap">
      <!-- 面包屑 -->
      <nav class="breadcrumb">
        <a class="bc-link" @click.prevent="goHome">首页</a>
        <span class="bc-sep">/</span>
        <span class="bc-link">{{ title }}</span>
        <span class="bc-sep">/</span>
        <span class="bc-current">{{ isOrderDetail ? '订单详情' : '预测结果' }}</span>
      </nav>

      <!-- Hero 头部 -->
      <div class="hero-row">
        <!-- <div class="hero-left">
          <p class="hero-brand">关盈堂 · {{ title || '健康服务' }}</p>
          <h1 class="hero-title">{{ title }}结果</h1>
          <p class="hero-subtitle">静心阅读，了解身体，关照日常。</p>
        </div> -->
        <button class="hero-back" type="button" @click="backToPrev">
          <span class="hero-back-arrow" aria-hidden="true">←</span>
          <span>返回</span>
        </button>
      </div>

      <!-- 报告卡 -->
      <section class="report-card">
        <div class="report-head">
          <div class="report-head-left">
            <h2 class="report-title">{{ isOrderDetail ? '订单详情' : '健康参考报告' }}</h2>
          </div>
        </div>

        <!-- 健康指引 / 五运信息 Tab -->
        <div class="result-tabs" v-if="showResultTabs">
          <button type="button" class="tab-btn" :class="{ active: activeTab === 'predict' }"
            @click="activeTab = 'predict'">
            健康指引
          </button>
          <button type="button" class="tab-btn" :class="{ active: activeTab === 'wuyun' }" @click="activeTab = 'wuyun'">
            五运信息
          </button>
        </div>

        <!-- 结果内容 -->
        <div class="report-body">
          <template v-for="(item, index) in displayLines">
            <h3 v-if="isSectionLine(item)" :key="'h' + index" class="report-section">{{ item }}</h3>
            <p v-else :key="'p' + index" class="report-line">
              <WordSegment v-if="
                (serviceIndex == 4 && index == 2) ||
                (serviceIndex == 1 && item.includes('适宜穴位')) ||
                (serviceIndex == 1 && item.includes('适宜按摩穴位'))
              " :inputText="item" :list="list" />
              <span v-else>{{ item }}</span>
            </p>
          </template>
          <p class="remark" v-if="serviceIndex == 4 || activeTab === 'wuyun'">
            （备注：可点击以上穴位名称，获取详细信息。）
          </p>
        </div>

        <!-- 卡内页脚 -->
      </section>

      <!-- 底部行 -->
      <div class="result-bottom">
        <p class="result-tip" v-if="!isOrderDetail">温馨提示：健康指引仅供参考，不作为医学诊断或治疗依据。如有持续不适，请及时就医。</p>
        <p class="result-tip" v-else>以上为该订单记录的最终内容，如有疑问请联系客服核对。</p>
        <div class="result-actions">
          <!-- <button class="ai-btn" type="button" @click="sendToAiDialog">
            <i class="el-icon-chat-dot-round"></i>
            <span>一键输入到AI对话框</span>
          </button> -->
          <!-- <button class="next-btn" type="button" v-if="serviceIndex == 9" @click="nextStep">下一步</button> -->
          <!-- <button class="back-service-btn" type="button" @click="goBack">
            <span>返回我的服务</span>
            <span class="back-arrow" aria-hidden="true">→</span>
          </button> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WordSegment from "./WordSegment.vue";
import { EventBus } from "../js/eventbus.js";
import utils from "../js/utils.js";
export default {
  data() {
    return {
      results: [],
      title: "",
      list: [],
      serviceIndex: "",
      consultInfo: "",
      visitRecordId:"",
      // 订单详情模式：路由带 visitRecordId 时，按订单号请求文本详情
      orderNo: "",
      fromPath: "/",
      activeTab: "predict",
      normalPredictionInfo: "",
    };
  },
  components: {
    WordSegment,
  },
  created() {
    // 订单详情模式：/serviceResult?visitRecordId=xxx
    // 命中则按订单号请求纯文本详情并直接 return，原有预测流程完全不受影响
    var orderNo = this.$route.query.visitRecordId;
    if (orderNo && String(orderNo).length > 0) {
      this.orderNo = String(orderNo);
      this.loadOrderText(this.orderNo);
      return;
    }
    var serviceInfo = JSON.parse(sessionStorage.getItem("serviceInfo"));
    var patientId = serviceInfo.patientId;
    var useDate = serviceInfo.useDate;
    var useDays = serviceInfo.useDays;
    var serviceIndex = serviceInfo.serviceIndex;
    this.serviceIndex = serviceInfo.serviceIndex;
    var params = {
      patientId: patientId,
    };
    console.log("created");
    // console.log("serviceIndex:"+serviceIndex)
    var url = "";
    if (serviceIndex == 1) {
      document.title = "健康指引结果";
      this.title = "健康指引";
      url = "/api/health/v1/disease";
      params.toPredictDay = useDate.replace(/-/g, "");
      params.predictDays = useDays;
    } else if (serviceIndex == 2) {
      document.title = "本草茶饮结果";
      this.title = "本草茶饮";
      url = "/api/health/v1/dietTherapy";
    } else if (serviceIndex == 3) {
      document.title = "经络调理结果";
      this.title = "经络调理";
      url = "/api/health/v1/massage";
    } else if (serviceIndex == 4) {
      document.title = "针灸结果";
      this.title = "针灸";
      url = "/api/health/v1/acupuncture";
    } else if (serviceIndex == 5) {
      document.title = "本草压片结果";
      this.title = "本草压片";
      url = "/api/health/v1/medicine";
    } else if (serviceIndex == 9) {
      document.title = "私人定制养生茶结果";
      this.title = "私人定制养生茶";
      url = "/api/health/v1/customTea";
      params.toPredictDay = useDate.replace(/-/g, "");
      params.predictDays = useDays;
    } else if (serviceIndex == 10) {
      document.title = "药食同源结果";
      this.title = "药食同源";
      url = "/api/health/v1/medicine";
    } else if (serviceIndex == 11) {
      document.title = "六气汤结果";
      this.title = "六气汤";
      url = "/api/health/v1/liuQiYin";
    } else if (serviceIndex == 12) {
      document.title = "新健康指引";
      this.title = "新健康指引";
      url = "/api/health/v1/newDisease";
      params.toPredictDay = useDate.replace(/-/g, "");
      params.predictDays = useDays;
    }
    if (serviceIndex != 1 && serviceIndex != 9) {
      params.toDoDay = useDate;
      if (!this.utils.isEmptyStr(useDays)) {
        params.takeDays = useDays;
      }
    }

    console.log(url);
    this.wjtHttp.post(
      this,
      url,
      params,
      false,
      (res) => {
        var data = res.data;
        if (data.code == 200) {
          var rs = "";
          if (serviceIndex == 9) {
            rs = data.data.customTeaResult.split("\n");
            this.visitRecordId = data.data.visitRecordId;
          } else if (serviceIndex == 1) {
            // 健康指引接口返回新结构：data为结果文本，patient为患者信息
            rs = data.data.split("\n");
            this.consultInfo = data.patient;
            // 五运信息（normalPredictionInfo 可能为多行文本或JSON对象/数组）
            if (data.normalPredictionInfo) {
              this.normalPredictionInfo = data.normalPredictionInfo;
            }
          } else {
            // 兼容：本草茶饮(2)/本草压片(5) 等接口的 data 可能是字符串、数组或对象，
            // 直接 split 会在非字符串时抛错
            var raw = data.data;
            if (typeof raw === "string") {
              rs = raw.split("\n");
            } else if (Array.isArray(raw)) {
              rs = raw.map((it) => (typeof it === "string" ? it : JSON.stringify(it)));
            } else if (raw && typeof raw === "object") {
              var text = raw.result || raw.content || raw.text || raw.dietTherapyResult || raw.medicineResult || "";
              if (!text) {
                for (var key in raw) {
                  if (typeof raw[key] === "string" && raw[key]) {
                    text = raw[key];
                    break;
                  }
                }
              }
              rs = String(text || "").split("\n");
            } else {
              rs = [];
            }
          }
          var newRS = [];
          rs.forEach((val, index) => {
            if (val.length != 0) {
              newRS.push(val.replace(/ /g, ""));
            }
          });
          this.results = newRS;
        } else {
          this.$message({
            message:
              data.msg && data.msg.length > 0
                ? data.msg
                : "搜索异常，请联系管理员",
            type: "error",
          });
        }
      },
      (err) => {
        console.log(err);
      }
    );
    // this.get()
  },
  computed: {
    // 是否处于「订单详情」模式（与预测结果模式区分）
    isOrderDetail() {
      return !!this.orderNo;
    },
    // 是否展示顶部tab（仅健康指引且有五运信息时）
    showResultTabs() {
      return this.serviceIndex == 1 && this.wuyunLines.length > 0;
    },
    // 当前tab展示的内容行
    displayLines() {
      if (this.serviceIndex == 1 && this.activeTab === "wuyun" && this.wuyunLines.length > 0) {
        return this.wuyunLines;
      }
      return this.results;
    },
    // 将五运信息（normalPredictionInfo）解析为展示行
    wuyunLines() {
      var info = this.normalPredictionInfo;
      if (!info) return [];
      if (typeof info === "string") {
        var trimInfo = info.trim();
        // 若是JSON字符串，则解析后按对象处理
        if ((trimInfo.charAt(0) === "{" || trimInfo.charAt(0) === "[") && trimInfo.indexOf("\n") === -1) {
          try {
            info = JSON.parse(trimInfo);
          } catch (e) {
            info = info.split("\n");
          }
        } else {
          info = info.split("\n");
        }
      }
      var lines = [];
      var collect = (val, prefix) => {
        if (val === null || val === undefined || val === "") return;
        if (typeof val === "string" || typeof val === "number") {
          String(val).split("\n").forEach((v) => {
            v = String(v).replace(/ /g, "");
            if (v.length > 0) lines.push(prefix + v);
          });
        } else if (Array.isArray(val)) {
          val.forEach((item) => collect(item, prefix));
        } else if (typeof val === "object") {
          Object.keys(val).forEach((key) => {
            var item = val[key];
            if (item === null || item === undefined || item === "") return;
            if (typeof item === "object") {
              collect(item, prefix);
            } else {
              collect(item, prefix + "【" + key + "】");
            }
          });
        }
      };
      collect(info, "");
      return lines;
    },
  },
  methods: {
    goBack() {
      this.$router.replace('/');
    },
    goHome() {
      this.$router.replace('/');
    },
    backToPrev() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.$router.replace('/');
      }
    },
    // 按订单号拉取订单纯文本详情（仅 本草茶饮T / 本草压片C / 健康指引D 支持）
    loadOrderText(visitRecordId) {
      var url = "/api/health/v1/prescription/order/text/" + encodeURIComponent(visitRecordId);
      this.wjtHttp.get(this, url, {}, false,
        (res) => {
          var data = res.data;
          if (data.code == 200) {
            var text = typeof data.data === "string" ? data.data : "";
            var lines = text.split("\n");
            var arr = [];
            for (var i = 0; i < lines.length; i++) {
              var v = lines[i];
              if (!v || v.replace(/\s/g, "").length == 0) continue;
              // 过滤纯分隔线（如 ------------------------）
              if (/^[-—_=*]{3,}$/.test(v.replace(/\s/g, ""))) continue;
              arr.push(v);
            }
            this.results = arr;
            // 首行形如【本草茶饮】订单详情，取其标题
            var m = (arr[0] || "").match(/【(.+?)】/);
            this.title = m ? m[1] : "订单";
            document.title = this.title + "详情";
          } else {
            this.results = [];
            this.$message({
              message: data.msg && data.msg.length > 0 ? data.msg : "查询订单详情失败",
              type: "error",
            });
          }
        },
        (err) => { console.log(err); }
      );
    },
    isSectionLine(item) {
      return typeof item === "string" && item.trim().indexOf("【") === 0;
    },
    nextStep() {
      this.$router.push({
        path: "/CUSTOMIZEDPrescription",
        query: {
          visitRecordId: this.visitRecordId,
        },
      });
    },
    handleMouseOver() {
      console.log(1111);
    },
    get() {
      this.wjtHttp.get(
        this,
        "/api/business/acupointDetails/listAll",
        {},
        false,
        (res) => {
          var data = res.data;
          if (data.code == 200) {
            this.list = data.data;
          } else {
            this.$message({
              message:
                data.msg && data.msg.length > 0
                  ? data.msg
                  : "搜索异常，请联系管理员",
              type: "error",
            });
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    sendToAiDialog() {
      // 获取健康指引的开始日期和持续天数
      const serviceInfo = JSON.parse(sessionStorage.getItem("serviceInfo"));
      const useDate = serviceInfo.useDate || '';
      const useDays = serviceInfo.useDays || '';
      
      // 构建患者信息行（姓名、健康开始日期、健康持续天数）
      let patientLine = '';
      if (this.consultInfo && typeof this.consultInfo === 'object' && this.consultInfo.name) {
        const blurredName = utils.blurName(this.consultInfo.name);
        patientLine = `患者：${blurredName}，健康开始日期：${useDate}，健康持续天数：${useDays}天`;
      } else if (this.consultInfo && typeof this.consultInfo === 'string' && this.consultInfo.length > 0) {
        // 如果consultInfo是字符串，尝试解析JSON
        try {
          const info = JSON.parse(this.consultInfo);
          if (info.name) {
            const blurredName = utils.blurName(info.name);
            patientLine = `患者：${blurredName}，健康开始日期：${useDate}，健康持续天数：${useDays}天`;
          }
        } catch (e) {
          // 忽略解析错误
        }
      }
      
      // 将当前tab内容行合并为字符串（健康指引结果 或 五运信息）
      const resultText = this.displayLines.join('\n');
      
      // 组合最终文本：患者信息行 + 换行 + 当前tab内容
      let text = '';
      if (patientLine) {
        text = patientLine + '\n' + resultText;
      } else {
        text = resultText;
      }

      // 通过事件总线发送
      EventBus.$emit('ai-input-text', {
        text: text,
        source: 'health_prediction',
        serviceIndex: this.serviceIndex
      });
      this.$message.success('已填充到AI对话框');
    },
  },
  beforeRouteEnter(to, from, next) {
    next(function(vm) {
      vm.fromPath = from.path;
    });
  },
};
</script>

<style scoped>
/* ============ 页面根容器 ============ */
.page-root {
  position: relative;
  min-height: 100vh;
  background: #f5f7f2;
  font-family: '思源黑体', 'Source Han Sans SC', 'Noto Sans SC', system-ui, sans-serif;
  color: #304744;
  padding-bottom: 40px;
}

.page-wrap {
  max-width: 1220px;
  margin: 0 auto;
  padding: 32px 24px 40px;
}

/* ============ 面包屑 ============ */
.breadcrumb {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
  margin-bottom: 18px;
}

.bc-link {
  color: #527f77;
  cursor: pointer;
}

.bc-link:hover {
  color: #009798;
}

.bc-sep {
  color: #b6c6c1;
}

.bc-current {
  color: #304744;
  font-weight: 600;
}

/* ============ Hero ============ */
.hero-row {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 26px;
}

.hero-brand {
  margin: 0 0 14px;
  font-size: 16px;
  font-weight: 600;
  color: #009798;
  letter-spacing: 1px;
}

.hero-title {
  margin: 0 0 12px;
  font-size: 40px;
  font-weight: 700;
  color: #304744;
  letter-spacing: 1px;
  line-height: 1.2;
}

.hero-subtitle {
  margin: 0;
  font-size: 17px;
  color: #527f77;
}

.hero-back {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 46px;
  padding: 0 22px;
  border: 1px solid #cfdcd8;
  border-radius: 12px;
  background: #fff;
  color: #304744;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.hero-back:hover {
  border-color: #009798;
  color: #009798;
}

.hero-back-arrow {
  color: #009798;
  font-weight: 700;
}

/* ============ 报告卡 ============ */
.report-card {
  background: #fff;
  border: 1px solid #e9efec;
  border-radius: 22px;
  padding: 34px 48px 24px;
  box-shadow: 0 10px 30px rgba(23, 61, 59, 0.06);
}

.report-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding-bottom: 20px;
  border-bottom: 1px solid #eef2f0;
}

.report-eyebrow {
  margin: 0 0 10px;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 2px;
  color: #a9bcb6;
}

.report-title {
  margin: 0;
  font-size: 28px;
  font-weight: 700;
  color: #304744;
}

.report-badge {
  flex-shrink: 0;
  padding: 6px 16px;
  border-radius: 999px;
  background: #e6f4f1;
  color: #009798;
  font-size: 16px;
  font-weight: 600;
}

.report-notice {
  margin: 20px 0 6px;
  padding: 14px 20px;
  border-radius: 10px;
  background: #fdf6e7;
  color: #a07d3a;
  font-size: 16px;
  line-height: 1.6;
}

/* ============ Tabs ============ */
.result-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin: 18px 0 6px;
}

.tab-btn {
  border: 1px solid #d3e6e3;
  background: #fff;
  color: #527f77;
  font-size: 16px;
  font-weight: 600;
  padding: 8px 24px;
  border-radius: 999px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: inherit;
}

.tab-btn:hover {
  background: #eaf6f4;
  color: #009798;
}

.tab-btn.active {
  background: #009798;
  border-color: #009798;
  color: #fff;
  box-shadow: 0 2px 8px rgba(0, 151, 152, 0.25);
}

/* ============ 结果内容 ============ */
.report-body {
  padding: 16px 0 6px;
}

.report-line {
  margin: 14px 0;
  font-size: 17px;
  line-height: 1.9;
  color: #4a5f5a;
  text-align: left;
}

.report-section {
  margin: 28px 0 10px;
  font-size: 20px;
  font-weight: 700;
  color: #009798;
  letter-spacing: 1px;
}

.report-body>.report-line:first-child {
  margin-top: 4px;
}

.remark {
  margin: 18px 0 0;
  font-size: 16px;
  color: #7f9994;
}

/* ============ 卡内页脚 ============ */
.report-footer {
  margin-top: 26px;
  padding-top: 20px;
  border-top: 1px solid #eef2f0;
  text-align: center;
  font-size: 16px;
  color: #9aa8a3;
  letter-spacing: 2px;
}

/* ============ 底部行 ============ */
.result-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-top: 22px;
  flex-wrap: wrap;
}

.result-tip {
  margin: 0;
  font-size: 16px;
  color: #9aa8a3;
  line-height: 1.6;
}

.result-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.ai-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 46px;
  padding: 0 22px;
  border: 1px solid #009798;
  border-radius: 12px;
  background: #fff;
  color: #009798;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.ai-btn:hover {
  background: #eaf6f4;
}

.ai-btn i {
  font-size: 18px;
}

.next-btn {
  height: 46px;
  padding: 0 30px;
  border: none;
  border-radius: 12px;
  background: #009798;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease;
}

.next-btn:hover {
  background: #007e7f;
}

.back-service-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 46px;
  padding: 0 22px;
  border: 1px solid #cfdcd8;
  border-radius: 12px;
  background: #fff;
  color: #304744;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.back-service-btn:hover {
  border-color: #009798;
  color: #009798;
}

.back-arrow {
  color: #009798;
  font-weight: 700;
}

/* ============ 兼容旧 Element 样式覆盖 ============ */
.page-root>>>.el-message-box,
.page-root>>>.el-notification {
  font-family: inherit;
}

/* ============ 响应式：窄屏 ============ */
@media (max-width: 768px) {
  .page-wrap {
    padding: 20px 16px 32px;
  }

  .hero-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }

  .hero-title {
    font-size: 28px;
  }

  .report-card {
    padding: 22px 18px 18px;
  }

  .report-head {
    flex-direction: column;
  }

  .report-title {
    font-size: 22px;
  }

  .report-line {
    font-size: 16px;
  }

  .result-bottom {
    flex-direction: column;
    align-items: flex-start;
  }

  .result-actions {
    width: 100%;
  }
}
</style>
